var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewmenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5229 0C9.89552 0 0.436523 9.45899 0.436523 21.0864C0.436523 32.7139 9.89552 42.1729 21.5229 42.1729C33.1504 42.1729 42.6094 32.7139 42.6094 21.0864C42.6094 9.45899 33.1504 0 21.5229 0ZM30.309 29.8725H12.7369C11.7652 29.8725 10.9797 29.0853 10.9797 28.1153C10.9797 27.1453 11.7652 26.3581 12.7369 26.3581H30.3089C31.2806 26.3581 32.0661 27.1453 32.0661 28.1153C32.0662 29.0852 31.2807 29.8725 30.309 29.8725ZM30.309 22.8436H12.7369C11.7652 22.8436 10.9797 22.0564 10.9797 21.0864C10.9797 20.1164 11.7652 19.3293 12.7369 19.3293H30.3089C31.2806 19.3293 32.0661 20.1164 32.0661 21.0864C32.0661 22.0564 31.2807 22.8436 30.309 22.8436ZM30.309 15.8148H12.7369C11.7652 15.8148 10.9797 15.0276 10.9797 14.0576C10.9797 13.0877 11.7652 12.3005 12.7369 12.3005H30.3089C31.2806 12.3005 32.0661 13.0877 32.0661 14.0576C32.0661 15.0276 31.2807 15.8148 30.309 15.8148Z",
    fill: "#E0AF04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewmenu);
export default __webpack_public_path__ + "static/media/newmenu.3e59b8394a01faf7c2e1f426b12fc623.svg";
export { ForwardRef as ReactComponent };